import {
  SELECT_PAYMENT_METHOD_API,
  SelectPaymentMethodApi,
  SelectPaymentMethodRequest,
} from './select-payment-method-api.js'
import {
  START_PAYMENT_API,
  StartMolliePaymentRequest,
  StartOnAccountPaymentRequest,
  StartPaymentApi,
} from './start-payment-api.js'
import { parseStartPaymentResponse } from './start-payment-parser.js'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const PAYMENT_BACKEND = Symbol('PAYMENT_BACKEND')


@registerDependency(REAL, PAYMENT_BACKEND)
@registerDependency(FAKE, PAYMENT_BACKEND)
export class PaymentBackend {
  @inject(START_PAYMENT_API)
  private startPaymentApi!: StartPaymentApi

  @inject(SELECT_PAYMENT_METHOD_API)
  private selectPaymentMethodApi!: SelectPaymentMethodApi

  selectPaymentMethod = async (request: SelectPaymentMethodRequest) => {
    return this.selectPaymentMethodApi.selectPaymentMethod(request)
  }

  startMolliePayment = async (request: StartMolliePaymentRequest) => {
    const responseBody = await this.startPaymentApi.startMolliePayment(request)
    return parseStartPaymentResponse(responseBody)
  }

  startOnAccountPayment = async (request: StartOnAccountPaymentRequest) => {
    const responseBody = await this.startPaymentApi.startOnAccountPayment(request)
    return parseStartPaymentResponse(responseBody)
  }
}
